export const ROUTES = {
  SIGN_CONTRACT: "/sign-contract",
  BUSINESS_HOURS: "/business-hours",
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  MERCHANT_REGISTRATION_INITIAL: "/merchant-registration-initial",
  FORGOTPASSWORD: "/forgot-password",
  FORGOTOTP: "/forgot-otp",
  SIGNAGREE: "/sign-agree",

  MERCHANT_REGISTRATION: "/merchant-registration",
  MERCHANT_REGISTRATION_KYB: "/merchant-registration-kyb",
  MERCHANT_REGISTRATION_KYB_NEXT: "/merchant-registration-kyb-next",
  MERCHANT_REGISTRATION_KYB_BUSINESSHOURS:
    "/merchant-registration-kyb-business-hours",
  MERCHANT_REGISTRATION_KYB_SIGN: "/merchant-registration-kyb-sign",

  DASHBOARD: "/dashboard",
  DASHBOARD_KYB: "/dashboard-kyb",

  FOOD_PAGE: "/food-page",
  MENU_MANAGEMENT: "/menu-management",
  BUNDLE_DEAL: "/bundle-deal",
  ADD_NEW_BUNDLE_DEAL: "/bundle-deal/entry/:id",
  ADD_NEW_FOOD_MENU: "/food/entry/:id",

  ORDERS: "/orders",
  ORDER_DETAILS: "/orders/:id",
  PROFILE: "/profile",
  REPORTS: "/reports",
  RATINGS: "/ratings",
  REVIEWS: "/reviews",
  DISCOUNT_VOUCHERS: "/discount-vouchers",
  ADD_VOUCHER: "/discount-vouchers/create",
  EDIT_VOUCHER: "/discount-vouchers/edit/:id",
  REVIEW_FOOD_MENU: "/review-food-menu",
  WALLET: "/wallet",
};
